import { render, staticRenderFns } from "./Bilibili.vue?vue&type=template&id=55cd3c10&scoped=true"
import script from "./Bilibili.vue?vue&type=script&lang=js"
export * from "./Bilibili.vue?vue&type=script&lang=js"
import style0 from "./Bilibili.vue?vue&type=style&index=0&id=55cd3c10&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "55cd3c10",
  null
  
)

export default component.exports